// lib/analytics.js
import axios from "axios";
import config from "../../src/config/config";

function generateUUID() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === "x" ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
export function getVisitorId() {
  let id = localStorage.getItem("visitor_id");
  if (!id) {
    id = generateUUID();
    localStorage.setItem("visitor_id", id);
  }
  return id;
}
export function getSessionId() {
  const MAX_INACTIVE_TIME = 30 * 60 * 1000; 
  let sessionId = sessionStorage.getItem("session_id");
  let lastActivity = sessionStorage.getItem("last_activity");
  const now = Date.now();

  if (!sessionId || !lastActivity || now - lastActivity > MAX_INACTIVE_TIME) {
    sessionId = generateUUID();
    sessionStorage.setItem("session_id", sessionId);
  }

  sessionStorage.setItem("last_activity", now);
  return sessionId;
}

export const logUserAction = async (actionObject) => {
  const payload = {
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    data: {
      ...actionObject,
    },
  };
  try {
    await axios.post(`${config.backendUrl}/analytics/writeLog`, payload);
  } catch (error) {
    console.error("Log writing failed:", error);
  }
};
